'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _SvgIcon = require('./SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MyCollection_Icon = function MyCollection_Icon(_ref) {
	var index = _ref.index,
	    item = _ref.item,
	    handleDelete = _ref.handleDelete,
	    openModal = _ref.openModal,
	    context = _ref.context,
	    type_internal = _ref.type_internal,
	    insertIntoOption = _ref.insertIntoOption,
	    status = _ref.status,
	    handleDownload = _ref.handleDownload;


	item['type_internal'] = type_internal;

	// Default
	var clickItem = function clickItem(event) {
		openModal(event, item, 'shortcode');
	};
	var insText = iconPressConfig.translations.COPY_CODE;

	// WP Editor Button
	if (context == 'wpeditor') {
		// Just Shortcode
		insText = iconPressConfig.translations.INSERT_SHORTCODE;
	}

	/**
  * ADD TO CUSTOMIZER OPTION
  * The icons won't open the customization modal, just insert the icon back to customizer.
  */
	else if (iconPressConfig.supported.indexOf(context) != -1) {
			clickItem = function clickItem(event) {
				insertIntoOption(event, item.internal_id, context);
			};
			insText = iconPressConfig.translations.INSERT_ICON;
		}

	return _react2.default.createElement(
		'div',
		{ className: 'ip-mcIcon ip-mcIcon--' + context + ' ' + (item.is_premium ? 'is-premium' : '') + ' ' + (item.type == 'upload' ? 'is-uploaded' : '') },
		type_internal !== 'system' && _react2.default.createElement(
			'div',
			{ className: 'ip-mcIcon-tb' },
			_react2.default.createElement(
				'div',
				{ className: 'ip-tbActive' },
				_react2.default.createElement(
					'div',
					{ className: 'ip-tbPlus' },
					_react2.default.createElement(_SvgIcon2.default, { icon: 'plus' })
				)
			),
			_react2.default.createElement(
				'div',
				{ className: 'ip-tbHover' },
				_react2.default.createElement(
					'ul',
					{ className: 'ip-tbBar ' + (status !== '' ? 'u-pevn' : '') },
					_react2.default.createElement(
						'li',
						null,
						_react2.default.createElement(
							'button',
							{ className: 'ip-tbBarBtn ip-tbBarBtn--attr ip-u-tooltip', 'data-tooltip': iconPressConfig.translations.ICON_INFORMATION_TOOLTIP, onClick: function onClick(event) {
									openModal(event, item, 'attribution');
								} },
							_react2.default.createElement(_SvgIcon2.default, { icon: 'info' })
						)
					),
					_react2.default.createElement(
						'li',
						null,
						_react2.default.createElement(
							'button',
							{ className: 'ip-tbBarBtn ip-tbBarBtn--plus' },
							_react2.default.createElement(_SvgIcon2.default, { icon: 'plus' })
						)
					),
					_react2.default.createElement(
						'li',
						null,
						_react2.default.createElement(
							'button',
							{ className: 'ip-tbBarBtn ip-tbBarBtn--delete ip-u-tooltip ' + (iconPressConfig.lock == 1 && item.user_id != iconPressConfig.user_id ? 'u-pevn' : ''), onClick: function onClick(event) {
									handleDelete(event, item.internal_id);
								}, 'data-tooltip': iconPressConfig.translations.DELETE_ICON },
							_react2.default.createElement(_SvgIcon2.default, { icon: status === 'delete' ? "spinner" : "trash" })
						)
					)
				)
			)
		),
		_react2.default.createElement(
			'div',
			{ className: 'ip-mcIcon-wrapper', onClick: clickItem },
			_react2.default.createElement(
				'div',
				{ className: 'ip-mcIcon-head' },
				_react2.default.createElement(
					'div',
					{ className: 'ip-mcIcon-iconHolder' },
					_react2.default.createElement(_SvgIcon2.default, { icon: '#' + item.internal_id, isCustom: true })
				)
			),
			_react2.default.createElement(
				'div',
				{ className: 'ip-mcIcon-actions' },
				_react2.default.createElement(
					'span',
					null,
					insText
				)
			)
		)
	);
};

exports.default = MyCollection_Icon;


//////////////////
// WEBPACK FOOTER
// ./src/components/MyCollection_Icon.js
// module id = 262
// module chunks = 0 1